import * as XLSX from 'xlsx';

/**
 * Generates a downloadable multi-sheet XLSX template for universal import.
 * Each sheet includes column headers and one example row.
 */
export function generateUniversalTemplate(): void {
  const workbook = XLSX.utils.book_new();

  // ---------------------------------------------------------------------------
  // location_types
  // ---------------------------------------------------------------------------
  const locationTypesData = [
    ['key', 'label', 'description', 'icon', 'isActive'],
    ['apartment_building', 'Apartment Building', 'Residential apartment complex', 'Building2', 'true'],
  ];
  const locationTypesSheet = XLSX.utils.aoa_to_sheet(locationTypesData);
  XLSX.utils.book_append_sheet(workbook, locationTypesSheet, 'location_types');

  // ---------------------------------------------------------------------------
  // organization_types
  // ---------------------------------------------------------------------------
  const organizationTypesData = [
    ['key', 'label', 'description', 'icon', 'isActive'],
    ['Center', 'Center', 'Community place of worship', 'Moon', 'true'],
  ];
  const organizationTypesSheet = XLSX.utils.aoa_to_sheet(organizationTypesData);
  XLSX.utils.book_append_sheet(workbook, organizationTypesSheet, 'organization_types');

  // ---------------------------------------------------------------------------
  // topic_types
  // ---------------------------------------------------------------------------
  const topicTypesData = [
    ['key', 'label', 'description', 'icon', 'isActive'],
    ['pillar', 'Pillar', 'Core pillars of faith', 'Layers', 'true'],
  ];
  const topicTypesSheet = XLSX.utils.aoa_to_sheet(topicTypesData);
  XLSX.utils.book_append_sheet(workbook, topicTypesSheet, 'topic_types');

  // ---------------------------------------------------------------------------
  // service_types
  // ---------------------------------------------------------------------------
  const serviceTypesData = [
    ['key', 'label', 'description', 'isActive'],
    ['prayer', 'Prayer', 'Daily prayer service', 'true'],
  ];
  const serviceTypesSheet = XLSX.utils.aoa_to_sheet(serviceTypesData);
  XLSX.utils.book_append_sheet(workbook, serviceTypesSheet, 'service_types');

  // ---------------------------------------------------------------------------
  // locations
  // ---------------------------------------------------------------------------
  const locationsData = [
    [
      'name',
      'locationCode',
      'locationTypeKey',
      'isPublic',
      'timezone',
      'parentLocationSlug',
      'slug',
    ],
    [
      'Downtown Center',
      'US-NY-00001',
      'apartment_building',
      'true',
      'America/New_York',
      '',
      'downtown-center',
    ],
  ];
  const locationsSheet = XLSX.utils.aoa_to_sheet(locationsData);
  XLSX.utils.book_append_sheet(workbook, locationsSheet, 'locations');

  // ---------------------------------------------------------------------------
  // organizations
  // ---------------------------------------------------------------------------
  const organizationsData = [
    ['name', 'slug', 'organizationTypeKey', 'description', 'isActive', 'parentOrganizationSlug'],
    ['Al-Noor Center', 'al-noor-Center', 'Center', 'Community Center serving downtown', 'true', ''],
  ];
  const organizationsSheet = XLSX.utils.aoa_to_sheet(organizationsData);
  XLSX.utils.book_append_sheet(workbook, organizationsSheet, 'organizations');

  // ---------------------------------------------------------------------------
  // topics
  // ---------------------------------------------------------------------------
  const topicsData = [
    ['name', 'slug', 'topicTypeKey', 'description', 'parentTopicSlug', 'isActive'],
    ['Prayer', 'Prayer', 'pillar', 'The daily prayers', '', 'true'],
  ];
  const topicsSheet = XLSX.utils.aoa_to_sheet(topicsData);
  XLSX.utils.book_append_sheet(workbook, topicsSheet, 'topics');

  // ---------------------------------------------------------------------------
  // sections
  // ---------------------------------------------------------------------------
  const sectionsData = [
    ['section_key', 'label_en', 'description_en', 'parent_section_key', 'order', 'isBase', 'isTypeSpecific'],
    ['about', 'About', 'General information', '', '1', 'true', 'false'],
  ];
  const sectionsSheet = XLSX.utils.aoa_to_sheet(sectionsData);
  XLSX.utils.book_append_sheet(workbook, sectionsSheet, 'sections');

  // ---------------------------------------------------------------------------
  // service_definitions
  // ---------------------------------------------------------------------------
  const serviceDefinitionsData = [
    [
      'name',
      'slug',
      'serviceTypeKey',
      'description',
      'typicalDuration',
      'isRecurring',
      'requiresBooking',
      'isActive',
    ],
    ['Fajr Prayer', 'fajr-prayer', 'prayer', 'Morning prayer', '30', 'true', 'false', 'true'],
  ];
  const serviceDefinitionsSheet = XLSX.utils.aoa_to_sheet(serviceDefinitionsData);
  XLSX.utils.book_append_sheet(workbook, serviceDefinitionsSheet, 'service_definitions');

  // ---------------------------------------------------------------------------
  // users
  // ---------------------------------------------------------------------------
  const usersData = [
    ['email', 'username', 'fullName', 'phoneNumber', 'platformRole', 'primaryLocationSlug'],
    ['user@example.com', 'john_doe', 'John Doe', '+1-555-1234', 'USER', 'downtown-center'],
  ];
  const usersSheet = XLSX.utils.aoa_to_sheet(usersData);
  XLSX.utils.book_append_sheet(workbook, usersSheet, 'users');

  // ---------------------------------------------------------------------------
  // Download
  // ---------------------------------------------------------------------------
  XLSX.writeFile(workbook, 'universal-import-template.xlsx');
}



